import Image from 'next/image';

import Banner from '../../components/BannerDefault';
import { customLoader } from '../../utils/customLoaderImage';

import style from './detalhes.module.scss';

const parse = require('html-react-parser');

interface Dados {
  dados: {
    titulo: string;
    banner: string;
    banner2: string;
    texto: string;
  };
}

export default function Detalhes({ dados }: Dados) {
  if (!dados) return null;

  return (
    <Banner
      image={{ src: '/img/backgroundpolitica.webp' }}
      width='100%'
      height='fit-content'>
      <div className={style.section}>
        <div className={style.text}>
          <h2>{parse(dados.titulo)}</h2>
          <p>{parse(dados.texto)}</p>
        </div>

        <div>
          <div className={style.decor1} />
          <figure className={style.banner2}>
            <Image
              alt={dados.titulo}
              src={dados.banner2 || '/img/image_icon.png'}
              loader={customLoader}
              objectFit='cover'
              layout='fill'
              priority
            />
            <figcaption>
              Imagem:
              {dados.titulo}
            </figcaption>
          </figure>
          <div className={style.decor2} />
          <figure className={style.banner}>
            <Image
              alt={dados.titulo}
              src={dados.banner || '/img/image_icon.png'}
              loader={customLoader}
              objectFit='cover'
              layout='fill'
              priority
            />
            <figcaption>
              Imagem:
              {dados.titulo}
            </figcaption>
          </figure>
        </div>
      </div>
    </Banner>
  );
}
